import { t } from "@lingui/core/macro";
import { RegrelloTypography } from "@regrello/ui-core";
import { validatePassword } from "../../../../utils/passwordRulesRegexUtils";
import { PasswordRuleListItem } from "./PasswordRuleListItem";

export function PasswordRuleList({ password }: { password: string }) {
  const passwordRules = validatePassword(password);

  return (
    <RegrelloTypography component="div">
      <PasswordRuleListItem
        isValid={passwordRules.minLength}
        showInvalidAsError={password.length > 0}
        text={t`At least 15 characters long`}
      />

      <PasswordRuleListItem
        isValid={passwordRules.hasValidCharacterCombination}
        showInvalidAsError={password.length > 0}
        text={t`At least 3 of the following:`}
      />

      <div className="pl-7">
        <PasswordRuleListItem isValid={passwordRules.hasUppercaseLetter} text={t`Upper case letter (A-Z)`} />
        <PasswordRuleListItem isValid={passwordRules.hasLowercaseLetter} text={t`Lower case letter (a-z)`} />
        <PasswordRuleListItem isValid={passwordRules.hasNumber} text={t`Number (1-9)`} />
        <PasswordRuleListItem isValid={passwordRules.hasSpecialCharacter} text={t`Special character (!@#$%^&*)`} />
      </div>

      <PasswordRuleListItem
        isValid={passwordRules.hasNoConsecutiveCharacters}
        showInvalidAsError={password.length > 0}
        text={t`No more than 2 identical characters in a row (aaa is not allowed)`}
      />
    </RegrelloTypography>
  );
}
